<!--
@Author: Calvin Green <calvin>
@Date:   2022-03-18T14:07:39+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-08-29T09:43:20+02:00
@Copyright: Diversitude 2022
-->

<template>
    <b-row>
        <b-col cols="12">
            <b-overlay :show="!ready" no-wrap></b-overlay>
        </b-col>
        <b-col cols="12" v-if="ready">
            <div v-if="action == 'view'">
                <div style="margin-top: 10px; margin-bottom: 10px;">
                    <b-button variant="primary" @click="setAction('add')">Add Location</b-button>
                </div>
                <LocationsTable :foliaLocations="foliaLocations" @reloadLocations="reloadLocations"></LocationsTable>
            </div>
            <div class="col-sm-6" v-if="action == 'add'">
                <div style="margin-top: 10px; margin-bottom: 10px;">
                    <b-button variant="primary" @click="setAction('view')">Back</b-button>
                </div>
                <addLocationForm
                    class="p-2"
                    style="border: 1px solid lightgrey;"
                    :types="locationTypes"
                    :foliaLocations="foliaLocations"
                />
            </div>
        </b-col>
    </b-row>
</template>

<script>
import { facilityAdminState, facilityAdminMethods } from '@/state/helpers'
import LocationsTable from './locationsTable.vue'
import addLocationForm from './addLocationForm.vue'
export default {
    data:() => ({
        action: 'view',
        ready: false
    }),
    components: {
        LocationsTable,
        addLocationForm
    },
    computed:{
        ...facilityAdminState,
        locationTypes() {
            return this.location_types;
        },
        foliaLocations() {
            return this.folia_locations;
        }
    },
    methods:{
        ...facilityAdminMethods,
        setAction(action) {
            this.action = action;
        },
        reloadLocations() {
            this.ready = false;
            this.loadClientLocations().then(()=>{
                this.$nextTick(() => {
                    this.ready = true;
                });
            });
        }
    },
    mounted(){
        if (this.folia_locations.length == 0) {
            this.loadFoliaLocations().then(()=>{
                if (this.client_locations.length == 0) {
                    this.loadClientLocations().then(()=>{
                        this.$nextTick(() => {
                            this.ready = true;
                        });
                    });
                } else {
                    this.$nextTick(() => {
                        this.ready = true;
                    });
                }
            });
        } else {
            this.$nextTick(() => {
                this.ready = true;
            });
        }
        if (this.location_types.length == 0) {
            this.loadLocationTypes();
        }
    },
}
</script>

<style>

</style>
